import { custom_instance } from "@/api/axios-instance";

type OidcStartResponse = {
  authorize_url: string;
};

type BffErrorMessage = {
  message?: string;
};

export async function startMicrosoftLogin(nextUrl: string): Promise<void> {
  const params = nextUrl ? { next: nextUrl } : undefined;
  const response = await custom_instance<OidcStartResponse>({
    url: "/app/bff/auth/oidc/start/",
    method: "GET",
    params,
  });
  if (!response.authorize_url) {
    // Let the caller fall through to the translated microsoftLoginError key.
    const error: BffErrorMessage = {};
    throw error;
  }
  window.location.href = response.authorize_url;
}
